import { render, staticRenderFns } from "./XhUser.vue?vue&type=template&id=213f7f15&scoped=true"
import script from "./XhUser.vue?vue&type=script&lang=js"
export * from "./XhUser.vue?vue&type=script&lang=js"
import style0 from "./XhUser.vue?vue&type=style&index=0&id=213f7f15&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213f7f15",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('213f7f15')) {
      api.createRecord('213f7f15', component.options)
    } else {
      api.reload('213f7f15', component.options)
    }
    module.hot.accept("./XhUser.vue?vue&type=template&id=213f7f15&scoped=true", function () {
      api.rerender('213f7f15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CreateCom/XhUser.vue"
export default component.exports